import useLocalStorage from "hooks/useLocalStorage";
import React, { createContext, useContext } from "react";

interface PageWidthViewContextType {
  setFullWidthView: (enabled: boolean) => void;
  fullWidthView: boolean;
}

export const PageWidthViewContext = createContext<PageWidthViewContextType>(
  {} as PageWidthViewContextType
);

export const PageWidthViewContextProvider = ({
  children,
}: React.PropsWithChildren) => {
  const [fullWidthView, setFullWidthView] = useLocalStorage<boolean>(
    "fullWidthView",
    false
  );

  return (
    <PageWidthViewContext.Provider
      value={{
        fullWidthView,
        setFullWidthView,
      }}
    >
      {children}
    </PageWidthViewContext.Provider>
  );
};

export const usePageWidthViewContext = () => useContext(PageWidthViewContext);
